<template>
  <b-table
    class="mb-0"
    striped
    small
    hover
    responsive
    no-sort-reset
    :items="results"
    :fields="fields"
    no-local-sorting
    :show-empty="!results.length"
    :empty-text="$gettext('no results found')"
    @sort-changed="sortChanged"
    sticky-header="80vh"
  >
    <template v-slot:cell(index)="{ index }">
      {{ pageIndex + index + 1 }}
    </template>
    <template v-slot:cell(inflections)="{ item }">
      {{ item.name_inflect }} (m),
      {{ item.subdivision_inflect }} (m),
    </template>
    <template v-slot:cell(buttons)="{ item }">
      <edit-delete-buttons
        @edit="edit(item.code)"
        @remove="remove(item.code)"
      />
    </template>
  </b-table>
</template>

<script>
export default {
  props: ['results', 'fields', 'pageIndex'],
  methods: {
    edit(code) {
      this.$emit('edit', code)
    },
    remove(code) {
      this.$emit('remove', code)
    },
    sortChanged(ctx) {
      this.$emit('sort-changed', ctx)
    },
  },
}
</script>
